import { TripsLayer } from 'deck.gl';

export const tripLayer = (gpsData: any) => {
  const path = gpsData?.map((p: any) => [p.lon, p.lat]);
  const timestamp = gpsData?.map((p: any) => p.timestamp);
  const layerData = [
    {
      path,
      timestamp,
    },
  ];
  return new TripsLayer({
    id: 'trip-layer',
    data: layerData,
    getPath: (d) => d.path,
    getFilterValue: (d: any) => d.timestamp,
    getColor: [0, 0, 0, 255],
    trailLength: 10090,
    capRounded: true,

    jointRounded: true,
    widthMinPixels: 3,
  });
};
